(function () {
  'use strict';

  /* @ngdoc object
   * @name importacaoMotorista
   * @description
   *
   */
  angular
    .module('importacaoMotorista', [
      'ui.router'
    ]);
}());
